// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header h1{line-height:1.3}header img{border-radius:2rem}header a{font-size:1.2rem}@media (max-width: 767.98px){header h1{line-height:1.1;font-size:2rem}header a{font-size:1rem}}\n", ""]);
// Exports
module.exports = exports;
